import {
  EClickableTarget,
  EClickableTypes,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { EThemes } from '@/lib/contentstack-sdk/types';
import { IOrThreeBlocksProps } from './or-three-blocks.types';

export const orThreeBlocksMockData: IOrThreeBlocksProps = {
  mainCard: {
    theme: EThemes.DARK,
    icon: EIcons.CHAT,
    title: 'Have Questions? Let’s Talk',
    description:
      'We’re here to make the home building process easy, delightful, and within reach.',
    showCta: true,
    link: {
      variant: 'DIMINUTIVE',
      type: EClickableTypes.CTA,
      size: 'LG',
      url: { href: '#', title: 'Start a Live Chat' },
      outline: true,
      label: 'Start a Live Chat',
      target: EClickableTarget.BLANK,
    },
  },
  complementaryCards: [
    {
      title: 'Where We Build: Explore our interactive map',
      description: 'description - Where We Build: Explore our interactive map',
      theme: EThemes.DARK,
      bgImage: {
        mobile_image_url: '/assets/three-blocks/image_area.jpg',
        tablet_image_url: '/assets/three-blocks/image_area.jpg',
        desktop_image_url: '/assets/three-blocks/image_area.jpg',
        entry_title: 'Where We Build: Explore our interactive map',
        alt: 'Where We Build: Explore our interactive map',
      },
      showCta: false,
      link: {
        variant: 'DIMINUTIVE',
        type: EClickableTypes.CTA,
        size: 'LG',
        url: { href: '/where-we-build', title: 'Where we build' },
        outline: true,
        label: 'Where we build',
        target: EClickableTarget.BLANK,
      },
    },
    {
      title: 'Visit a design center near you',
      description: 'description - Visit a design center near you',
      theme: EThemes.DARK,
      bgImage: {
        mobile_image_url: '/assets/three-blocks/image_visit_center.jpg',
        tablet_image_url: '/assets/three-blocks/image_visit_center.jpg',
        desktop_image_url: '/assets/three-blocks/image_visit_center.jpg',
        entry_title: 'Visit a design center near you',
        alt: 'Visit a design center near you',
      },
      showCta: false,
      link: {
        variant: 'DIMINUTIVE',
        type: EClickableTypes.CTA,
        size: 'LG',
        url: {
          href: '/visit-a-design-center',
          title: 'Visit a design center',
        },
        outline: true,
        label: 'Visit a design center',
        target: EClickableTarget.BLANK,
      },
    },
    {
      title: 'Not to be rendered',
      description: 'description - Not to be rendered',
      theme: EThemes.DARK,
      bgImage: {
        mobile_image_url: '/assets/three-blocks/image_area.jpg',
        tablet_image_url: '/assets/three-blocks/image_area.jpg',
        desktop_image_url: '/assets/three-blocks/image_area.jpg',
        entry_title: 'Where We Build: Explore our interactive map',
        alt: 'Not to be rendered - Where We Build: Explore our interactive map',
      },
      showCta: false,
      link: {
        variant: 'DIMINUTIVE',
        type: EClickableTypes.CTA,
        size: 'LG',
        url: { href: '/where-we-build', title: 'Where we build' },
        outline: true,
        label: 'not to be rendered - Where we build',
        target: EClickableTarget.BLANK,
      },
    },
  ],
};
